<div class="events">
  <mat-toolbar class="mat-accent m-0 eventToolbar">
    <mat-toolbar-row class="eventCardheader">
      <span class="title dialog-title">Events</span>
      <div class="eventCardheader_options">
        <button
          mat-icon-button
          [matMenuTriggerFor]="optionsMenu"
          matTooltip="Search Param">
          <mat-icon>more_vert</mat-icon>
        </button>
        <button
          [matMenuTriggerFor]="FilterMenu"
          mat-icon-button
          *ngIf="isfilterApplied && appliedFilters.length >= 0"
          (click)="showFilter = !showFilter"
          style="margin-left: 10px"
          [matBadge]="appliedFilters.length"
          matBadgeColor="warn"
          matTooltip="Apply Filter">
          <mat-icon>shopping_cart</mat-icon>
        </button>

        <button
          [matMenuTriggerFor]="FilterMenu"
          mat-icon-button
          *ngIf="!isfilterApplied"
          (click)="showFilter = !showFilter"
          matTooltip="Apply Filter">
          <mat-icon>shopping_cart</mat-icon>
        </button>
        <button
          mat-icon-button
          matTooltip="Clear Filter"
          (click)="removeFilters()">
          <mat-icon>remove_shopping_cart</mat-icon>
        </button>
        <mat-menu
          class="filterMenu"
          #FilterMenu="matMenu"
          style="z-index: 100; overflow: hidden">
          <lib-filter
            [filters]="filters"
            (filterApplied)="filterAppliedCallback($event)"
            (removeFilters)="removeFilterCallback()"></lib-filter>
        </mat-menu>
        <mat-menu #optionsMenu="matMenu" style="z-index: 100">
          <button mat-menu-item (click)="clearList()">Clear List</button>
          <ng-container *ngFor="let option of toolbarOptions; let i = index">
            <button
              mat-menu-item
              matTooltip="{{ option.Title }}"
              (click)="eventCardToolbarFunctionCallback(option.Callback)">
              {{ option.Title }}
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <!-- <div class="eventCardheader">
    <p>Events</p>
    <div class="eventCardheader_option">
      <button mat-icon-button type="button" title="Clear Events" (click)="clearList()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div> -->
  <mat-menu #rightMenu="matMenu" style="z-index: 100">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item>{{ item.content.EventId }}</button>
      <button mat-menu-item (click)="clearList()">Clear List</button>
      <button mat-menu-item (click)="showEventDetails(item.content)">
        View Event
      </button>
      <!-- <button mat-menu-item (click)="clickSnapShot()">SnapShot</button> -->
    </ng-template>
  </mat-menu>
  <div class="eventcards">
    <div
      class="eventcard_contextmenu"
      [style.left]="menuTopLeftPosition.x"
      [style.top]="menuTopLeftPosition.y"
      [matMenuTriggerFor]="rightMenu"></div>
    <mat-card
      class="event-card_card"
      *ngFor="let event of eventCards"
      (dblclick)="eventCardCallback(event)"
      (contextmenu)="onRightClick($event, { content: event })">
      <mat-card-title-group *ngIf="event">
        <div class="event-card_card_image">
          <img
            mat-card-md-image
            *ngIf="event.Images && event.Images.length > 0"
            src="{{ event.Images[0].Path }}" />
        </div>
        <div class="event-card_card_details">
          <div class="event-card_card_details_container">
            <mat-card-subtitle *ngIf="event.EventId > 0"> Event Id : {{
              event.EventId
            }}</mat-card-subtitle>
            <mat-card-subtitle *ngIf="event.DeviceName">Device Name : {{
              event.DeviceName
            }}</mat-card-subtitle>
            <mat-card-subtitle *ngIf="event.EventName"> Event Name : {{
              event.EventName
            }}</mat-card-subtitle>
            <ng-container *ngFor="let property of properties">
              <mat-card-subtitle *ngIf="getPropertyValue(property, event)">
                {{ property }} : {{ getPropertyValue(property, event) }}
              </mat-card-subtitle>
            </ng-container>
            
          </div>
          <div class="event-card_card_options_container">
            <button
              mat-raised-button
              color="primary"
              (click)="showEventDetails(event)">
              View
            </button>
            <button
              mat-raised-button
              color="primary"
              *ngFor="let option of cardOptions"
              (click)="eventCardFunctionCallback(option.Callback, event)">
              <mat-icon>{{ option.Icon }}</mat-icon>
            </button>
          </div>
        </div>
      </mat-card-title-group>
    </mat-card>
  </div>
</div>
